import React from "react";
import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import useAuthCheck from "./hooks/useAuthCheck";
import AdminLogin from "./pages/admin/AdminLogin";
import AssignmentMark from "./pages/admin/AssignmentMark";
import AddAssignment from "./pages/admin/Assignments/AddAssignment";
import Assignments from "./pages/admin/Assignments/Assignments";
import EditAssignment from "./pages/admin/Assignments/EditAssignment";
import Dashboard from "./pages/admin/Dashboard";
import AddQuiz from "./pages/admin/Quizzes/AddQuiz";
import EditQuiz from "./pages/admin/Quizzes/EditQuiz";
import Quizzes from "./pages/admin/Quizzes/Quizzes";
import AddVideo from "./pages/admin/videos/AddVideo";
import EditVideo from "./pages/admin/videos/EditVideo";
import Videos from "./pages/admin/videos/Videos";
import CoursePlayer from "./pages/students/CoursePlayer";
import Leaderboard from "./pages/students/Leaderboard";
import Quiz from "./pages/students/Quiz";
import StudentLogin from "./pages/students/StudentLogin";
import StudentReistration from "./pages/students/StudentReistration";

function App() {
  const authChecked = useAuthCheck();

  return !authChecked ? (
    <div>Checking authentication....</div>
  ) : (
    <Routes>
      <Route
        path="/"
        element={
          <PublicRoute>
            <StudentLogin />
          </PublicRoute>
        }
      />
      {/* Admin Routes */}
      <Route path="admin">
        <Route
          path="login"
          element={
            <PublicRoute>
              <AdminLogin />
            </PublicRoute>
          }
        />
        <Route
          path="dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="videos"
          element={
            <PrivateRoute>
              <Videos />
            </PrivateRoute>
          }
        />
        <Route
          path="addvideo"
          element={
            <PrivateRoute>
              <AddVideo />
            </PrivateRoute>
          }
        />
        <Route
          path="editvideo/:id"
          element={
            <PrivateRoute>
              <EditVideo />
            </PrivateRoute>
          }
        />

        <Route
          path="assignments"
          element={
            <PrivateRoute>
              <Assignments />
            </PrivateRoute>
          }
        />
        <Route
          path="addassignment"
          element={
            <PrivateRoute>
              <AddAssignment />
            </PrivateRoute>
          }
        />
        <Route
          path="editassignment/:id"
          element={
            <PrivateRoute>
              <EditAssignment />
            </PrivateRoute>
          }
        />
        <Route
          path="quizzes"
          element={
            <PrivateRoute>
              <Quizzes />
            </PrivateRoute>
          }
        />
        <Route
          path="addquiz"
          element={
            <PrivateRoute>
              <AddQuiz />
            </PrivateRoute>
          }
        />
        <Route
          path="editquiz/:id"
          element={
            <PrivateRoute>
              <EditQuiz />
            </PrivateRoute>
          }
        />
        <Route
          path="assignmentmark"
          element={
            <PrivateRoute>
              <AssignmentMark />
            </PrivateRoute>
          }
        />
      </Route>
      <Route path="student">
        <Route
          path="login"
          element={
            <PublicRoute>
              <StudentLogin />
            </PublicRoute>
          }
        />
        <Route
          path="register"
          element={
            <PublicRoute>
              <StudentReistration />
            </PublicRoute>
          }
        />
        <Route
          path="course"
          element={
            <PrivateRoute>
              <CoursePlayer />
            </PrivateRoute>
          }
        />
        <Route
          path="leaderboard"
          element={
            <PrivateRoute>
              <Leaderboard />
            </PrivateRoute>
          }
        />
        <Route
          path="quiz/:id"
          element={
            <PrivateRoute>
              <Quiz />
            </PrivateRoute>
          }
        />
      </Route>

      <Route path="*" element={<h1>404: Not Found</h1>} />
    </Routes>
  );
}

export default App;
